<script setup lang="ts">
import DRBtnIcon from "@/components/UI/DRBtnIcon.vue";
import DRDropdownItem from "@/components/UI/DRDropdownItem.vue";
import MoveDrawingItem from "./MoveDrawingItem.vue";
import LinkDiagnosticItem from "./LinkDiagnosticItem.vue";
import RenameBtnItem from "./RenameBtnItem.vue";
import ArchiveBtnItem from "./ArchiveBtnItem.vue";
import DownloadDwgBtnItem from "./DownloadDwgBtnItem.vue";
import DownloadAllBranchesBtnItem from "./DownloadAllBranchesBtnItem.vue";
import type { DRLocalDrawingMeta, DRDrawing } from "@/types";
import { useNavigate } from "@/composable/useNavigate";
import { useTranslation } from "i18next-vue";

const props = defineProps<{
  drawing: DRDrawing;
  localData?: DRLocalDrawingMeta;
  selected?: boolean;
  disableSelect?: boolean;
  /** Masque l'accès à l'ouvrage (on y est déjà) */
  hideDiagnostic?: boolean;
}>();

const emit = defineEmits<{
  (e: "toggle-select"): void;
}>();

const { t } = useTranslation();
const { navigateDiagnostic } = useNavigate();

const openDiagnostic = () => {
  if (props.drawing.diagnostic) navigateDiagnostic(props.drawing.diagnostic.id);
};
</script>

<template>
  <el-dropdown trigger="click" @click.stop.prevent>
    <DRBtnIcon
      icon="bi-three-dots"
      variant="flat"
      :size="30"
      @click.stop.prevent
      @dblclick.stop.prevent
    />

    <template #dropdown>
      <el-dropdown-menu>
        <DRDropdownItem
          v-if="!disableSelect"
          @select="emit('toggle-select')"
          icon="bi-check2-circle"
          :label="selected ? $t('unselect') : $t('select')"
        />
        <DownloadDwgBtnItem
          :drawing-id="drawing.id"
          :revision-id="drawing.lastRevision.id"
          :file-name="drawing.name"
        />
        <DownloadAllBranchesBtnItem
          v-if="drawing.branchesCount && drawing.branchesCount > 1"
          :drawing-id="drawing.id"
          :file-name="drawing.name"
        />
        <ArchiveBtnItem :drawing-id="drawing.id" />
        <RenameBtnItem :drawing-id="drawing.id" :drawing-name="drawing.name" />
        <MoveDrawingItem
          :drawing-id="drawing.id"
          :name="drawing?.name"
          :project-id="drawing?.projectId"
        />
        <LinkDiagnosticItem
          :drawing-id="drawing.id"
          :project-id="drawing.projectId"
          :drawing-name="drawing.name"
          :diagnostic="drawing.diagnostic"
        />
        <DRDropdownItem
          v-if="drawing.diagnostic && !hideDiagnostic"
          @select="openDiagnostic()"
          icon="bi-box-arrow-up-right"
          :label="t('dashboard:drawings.openDiagnostic')"
        />
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<style lang="scss" scoped></style>
